/* eslint-disable */

import React from "react";
import { useEffect, useState } from "react";

import RaindropLoadingElement from "../../../ui-components/raindrop-loading-element/raindrop-loading-element";
import RaindropScrollContainer from "../../../ui-components/raindrop-scroll-container/raindrop-scroll-container.tsx";
import { fetchUsersGet } from "../../../services/api-raindrop";
import { Link, useNavigate } from "react-router-dom";
import { isLocalEnvironment } from "../../../services/environment";
import Spacer from "../../../ui-components/spacer/spacer";
import StatusIndicator from "../../../ui-components/status-indicator/status-indicator";
import RaindropButton from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import UserLogo from "../../../ui-components/user-logo/user-logo";

const UserStatusIndicator = ({ status }) => {
  let statusTitle = "Unknown";
  let statusColor = "bg-color-status-unknown";

  if (status === "USER_STATUS_AWAITING_EMAIL_VALIDATION") {
    statusTitle = "Awaiting Validation";
    statusColor = "bg-color-status-warning";
  }
  if (status === "USER_STATUS_ACTIVE") {
    statusTitle = "Active";
    statusColor = "bg-color-status-good";
  }
  if (status === "USER_STATUS_INACTIVE") {
    statusTitle = "Inactive";
    statusColor = "bg-color-status-bad";
  }

  return <StatusIndicator title={statusTitle} statusColor={statusColor} />;
};

const UserRow = ({ userId, src, nameLegal, email, status }) => {
  return (
    <tr className="text-color-dark-text-primary text-lg text-left hover:bg-color-dark-background-tertiary">
      <td className="py-3 px-6">{nameLegal}</td>
      <td className="py-3 px-6">{email}</td>
      <td className="flex flex-row py-3 px-6 ">
        <UserStatusIndicator status={status} />
      </td>
      <td>
        <RaindropButton to={`/nimbus/users/${userId}`} title="Go to Profile" />
      </td>
    </tr>
  );
};
const UsersSearchTable = ({ users }) => {
  return (
    <table className="min-w-full  overflow-y-scroll">
      <thead>
        <tr className="border-y">
          <th className="py-3 px-6 text-left">Full Name</th>
          <th className="py-3 px-6 text-left">Email</th>
          <th className="py-3 px-6 text-left">Status</th>
        </tr>
      </thead>
      <tbody className="text-gray-600 text-sm font-light">
        {users.map((user) => {
          return (
            <UserRow
              userId={user.id}
              src={""}
              nameLegal={user.latest_pii.name_legal}
              email={user.latest_pii.email}
              status={user.latest_status.status}
            />
          );
        })}
      </tbody>
    </table>
  );
};

const NimbusUsersSearch = () => {
  const [users, setUsers] = useState(null);
  const [isError, setIsError] = useState(false);

  const [refreshCount, setRefreshCount] = useState(0);

  useEffect(() => {
    fetchUsersGet()
      .then((data) => {
        setUsers(data);
        console.log("🟢 (RD-317) - ", data);
      })
      .catch((error) => {
        console.log("🔴 (RD-318) - ", error);
        setIsError(true);
      });
  }, [refreshCount]);

  if (users === null) {
    return <RaindropLoadingElement />;
  }

  if (users.length === 0) {
    return (
      <div className="text-center">
        <div className="text-4xl font-bold text-color-raindrop-minor-again">
          No Users
        </div>
        <div className="text-lg text-color-text-secondary">
          There are no users in the database
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="text-center">
        <div className="text-4xl font-bold text-color-raindrop-minor-again">
          Error
        </div>
        <div className="text-lg text-color-text-secondary">
          We were unable to load the users
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col  text-center gap-2  w-full h-full overflow-y-scroll ">
      <div className="flex flex-row items-center gap-2 py-4">
        <RaindropButton
          title={"Refresh"}
          icon={"fa-sync"}
          onClick={() => setRefreshCount(refreshCount + 1)}
        />
        <div>Found {users.length} users.</div>
      </div>

      <UsersSearchTable users={users} />
    </div>
  );
};

export default NimbusUsersSearch;
